import React from 'react';
import { useGetTeamQuery } from '../../../features/team/teamApi';
import Member from './Member';

const MemberList = () => {

    const {data:team, isLoading, isError} = useGetTeamQuery();

    let content;

    if(isLoading){
        content = <div className='checkbox-container'>Loading...</div>
    }

    if(!isLoading && isError){
        content = <div className='checkbox-container'>something went wrong</div>
    }

    if(!isLoading && !isError && team?.length === 0){
        content = <div className='checkbox-container'>No team available</div>
    }

    if(!isLoading && !isError && team?.length > 0){
        content = team.map((member) => <Member key={member.id} name={member.name} avatar={member.avatar}/>)
    }

    return (
        <div className="mt-8">
        <h3 className="text-xl font-bold">Team Members</h3>
        <div className="mt-3 space-y-4">
          {content}
        </div>
      </div>
    );
};

export default MemberList;